export type SolutionLoadingBubbleProps = {
  /** When set (non-empty), shown in `.gac-assistant-intro`; omitted for dots-only loaders (e.g. DC/cache). */
  patienceLabel?: string;
  loadingAriaLabel: string;
  /** Matches intro/thanks rows inside `.gac-assistant-stack-body` */
  inAinaStack?: boolean;
  /** Extra classes on the outer shell (e.g. `gac-solution-loading-outer` + pane modifier) */
  wrapperClassName?: string;
};

/** Optional patience copy in assistant intro bubble + loading dots; dots-only when `patienceLabel` is omitted/empty */
export function SolutionLoadingBubble({
  patienceLabel,
  loadingAriaLabel,
  inAinaStack = false,
  wrapperClassName,
}: SolutionLoadingBubbleProps) {
  const showIntro = Boolean(patienceLabel?.trim());

  const outerClass = ["gac-solution-loading-shell", wrapperClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={outerClass} aria-busy="true" aria-label={loadingAriaLabel}>
      {showIntro ? (
        <div
          className={[
            "gac-assistant-intro",
            inAinaStack ? "gac-assistant-intro--in-aina-stack" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <p className="gac-assistant-intro-text">{patienceLabel}</p>
        </div>
      ) : null}
      <div className="gac-solution-loading-dots-row">
        <div className="gac-loading-dots" aria-hidden>
          <span className="gac-loading-dot gac-loading-dot--1" />
          <span className="gac-loading-dot gac-loading-dot--2" />
          <span className="gac-loading-dot gac-loading-dot--3" />
        </div>
      </div>
    </div>
  );
}
